<template>
  <div>
    <footer  v-if="!hideFooter">
      <div class="container">
        <div class="row row-1">
          <div class="col-md-12">
            <img src="@/assets/img/main-logo.png" width="150" />
          </div>
        </div>
        <div class="row row-2">
          <div class="col-md-6 footer-1">
            <h3>
              A collaborative site for the arts
              community to create their own stages globally.
            </h3>
            <ul class="list-inline">
              <li>
                <a href="#">
                  <img src="@/assets/img/media/instagram.png" />
                </a>
              </li>
              <li>
                <a href="#">
                  <img src="@/assets/img/media/twitter.png" />
                </a>
              </li>
              <li>
                <a href="#">
                  <img src="@/assets/img/media/youtube.png" />
                </a>
              </li>
              <li>
                <a href="#">
                  <img src="@/assets/img/media/facebook.png" />
                </a>
              </li>
            </ul>
          </div>
          <div class="col-md-3 footer-2">
            <ul class="list-unstyled">
              <li>
                <a href="#" class="active">
                  Community
                </a>
              </li>
              <li>
                <router-link to="/artists/">Artists</router-link>
              </li>
              <li>
                <a href="#">
                  Videos
                </a>
              </li>
              <li>
                <a href="#">
                  Projects
                </a>
              </li>
              <li>
                <router-link to="/stage/create/">Create a Stage</router-link>
              </li>
            </ul>
          </div>
          <div class="col-md-3 footer-3">
            <ul class="list-unstyled">
              <li>
                <router-link class="active" to="/about/">About Us</router-link>
              </li>
              <li>
                <router-link to="/contact/">Contact</router-link>
              </li>
              <li>
                <router-link to="/about/">Our Team</router-link>
              </li>
              <li>
                <router-link to="/press/">Press</router-link>
              </li>
              <li>
                <router-link to="/events/all/">Upcoming Events</router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="row row-3">
          <div class="col-md-12">
            <p>© 2019 Cardboard Stage. 2015 All Rights Reserved</p>
          </div>
        </div>
      </div>
    </footer>

    <!-- The Modal -->
    <div class="modal" id="deleteModal">
      <div class="modal-dialog">
        <div class="modal-content">

          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">Delete Record</h4>
            <button type="button" class="close" data-dismiss="modal">&times;</button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            Are you sure, you want to delete <span>this Record</span> ?
          </div>

          <!-- Modal footer -->
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" v-on:click="deleteFunction" :data-id="recordId">Yes</button>
            <button type="button" class="btn btn-danger" data-dismiss="modal">No</button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import axios from 'axios'
    import Vue from 'vue'
    import VueToast from 'vue-toast-notification'
    import 'vue-toast-notification/dist/index.css'
    import router from '../../router'
    Vue.use(VueToast)
    export default {
      name: 'AdminFooter',
        props:['dataId', 'dataModel'],
        watch: {
            dataId(newValue, oldValue) {
                this.recordId = newValue
            },
            dataModel(newValue, oldValue){
                this.model = newValue
            }
        },
      data () {
          var userdata = localStorage.getItem('cbs_admin_usertoken')
          if(userdata){
              userdata = JSON.parse(userdata)
          }
        return {
          hideFooter: true,
          msg: 'Welcome to Your Vue.js App',
          recordId: this.dataId,
            userData: userdata,
            model: this.dataModel
        }
      },
      methods: {
          deleteFunction: function (e) {
              axios.post('/delete', {
                  id: this.recordId,
                  model: this.model
              },{
                  headers: {
                      "content-type": "application/json",
                      "x-api-key": this.userData.token
                  }
              }).then(function (response) {
                  Vue.$toast.open(
                      {
                          message: 'Deleted successfully!',
                          type: 'success',
                          position: 'top-right'
                      }
                  )
                  location.reload()
              })
          }
      }
    }
</script>



// WEBPACK FOOTER //
// src/components/admin/Footer.vue